<script lang="ts">
    import { getContext, onDestroy, onMount } from "svelte";
    import { writable, readable } from "svelte/store";
    import type { InputType } from "sveltestrap/src/Input";
    import Input from "sveltestrap/src/Input.svelte";
    import type { FormTools, InputControl } from "../global";

    const _valid = writable(true);
    const formTools: FormTools = getContext('formTools');

    export const valid = readable($_valid, set => _valid.subscribe(set));

    export let type: InputType = 'text';
    export let value: string = '';
    export let checked: boolean = false;
    export let disabled: boolean = false;
    export let label: string = undefined;
    export let required: boolean = false;
    export let minlength: number = undefined;

    const inputControl: InputControl = { valid };
    const submit = formTools.submit;

    let inputElement: HTMLInputElement;
    let touched = false;

    onMount(() => {
        updateValidity();
        formTools.registerControl(inputControl);
    });

    onDestroy(() => formTools.removeControl(inputControl));

    function updateValidity(): void {
        if (!inputElement) {
            return;
        }
        _valid.set(inputElement.validity.valid);
    }

</script>

<Input
    {type}
    {required}
    {minlength}
    {label}
    {disabled}
    valid={touched && $valid}
    invalid={$submit && !$valid}
    bind:value
    bind:checked
    bind:inner={inputElement}
    on:focus={() => touched = true}
    on:input={updateValidity}
    on:change={updateValidity}
    on:blur={updateValidity} />